import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
const pinia = createPinia();
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import baseplugin from "./plugins/baseplugin";
import windowSizePlugin from "./plugins/windowSizePlugin";
import globalComponents from "./plugins/globalComponents";
import regexHelperPlugin from './plugins/regexHelperPlugin';
import "./assets/styles/base.css";

import storesPlugin from "./plugins/stores";
import BaseCalls from "@/services/BaseCalls";

loadFonts();

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(baseplugin);
app.use(windowSizePlugin);
app.use(globalComponents);
app.use(storesPlugin);
app.use(regexHelperPlugin);
// Service als globalen Provider bereitstellen
app.provide('baseCalls', BaseCalls);

app.mount("#app");
